export const setBranches = (payload) => {
    return {
        type:"SET_BRANCHES",
        payload
    }
}
